import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { LoadingState } from 'app/utils/callstate';
import { IPlColumnEntry, PlColumnState } from '../pl.types';
import { PlColumnActions } from '../actions';

export const adapter: EntityAdapter<IPlColumnEntry> = createEntityAdapter<
  IPlColumnEntry
>({
  selectId: (entry) => entry.key,
});

export const initialPlState: PlColumnState = adapter.getInitialState({
  companyId: undefined,
  key: undefined,
  callState: LoadingState.Init,
});

export const reducer = createReducer(
  initialPlState,
  on(
    PlColumnActions.plColumnLoadRequested,
    (state, { entries }): PlColumnState => {
      return entries
        ? adapter.addAll(entries, {
            ...state,
            callState: LoadingState.Loading,
          })
        : {
            ...state,
            callState: LoadingState.Loading,
          };
    }
  ),
  on(
    PlColumnActions.plColumnLoaded,
    (state, { entries }): PlColumnState => {
      return state.key
      ? adapter.updateMany(
          entries.map((entry) =>
            Object.assign({}, { id: entry.name, changes: entry })
          ),
          {
            ...state,
            callState: LoadingState.Loaded,
          }
        )
      : adapter.addAll(entries, {
          ...state,
          callState: LoadingState.Loaded,
        })
    }
  ),
  on(PlColumnActions.plAddColumnRequested, (state, _) => {
    return {
      ...state,
      callState: LoadingState.Loading,
    };
  }),
  on(PlColumnActions.plColumnAdded, (state, { entry }) => {
    return adapter.addOne(entry, {
      ...state,
      callState: LoadingState.Loaded,
    });
  })
);

export const {
  selectAll,
  selectEntities,
  selectIds,
  selectTotal,
} = adapter.getSelectors();
